'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;
// import { isEqual } from 'lodash';
// import { Expand, CodeCard, ModalPromotion, PCardBooking, Note, StepInput, FooterBooking } from 'components';

// import { browserHistory } from 'react-router';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _support = require('helpers/support');

var _Constant = require('helpers/Constant');

var _Images = require('helpers/Images');

var _Images2 = _interopRequireDefault(_Images);

var _components = require('components');

var _lib = require('helpers/lib');

var _booking = require('redux/modules/booking');

var bookingActions = _interopRequireWildcard(_booking);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// const CAMPAIGN_FIELD = ['name', 'typeVoucher', 'code', 'startDate', 'endDate', 'condition', 'userUsed'];
var BookingRequestDetail = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    submit: state.booking.submit,
    bookingRequest: state.booking.bookingRequest,
    bill: state.booking.bill,
    cancelBooking: state.booking.cancelBooking,
    toggleCancelSuccess: state.booking.toggleCancelSuccess,
    cancelBookingError: state.booking.cancelBookingError,
    toggleCancelError: state.booking.toggleCancelError
  };
}, {
  loadBookingRequest: bookingActions.loadBookingRequest,
  cancelBookingRequest: bookingActions.cancelBookingRequest
}), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(BookingRequestDetail, _Component);

  function BookingRequestDetail() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, BookingRequestDetail);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = BookingRequestDetail.__proto__ || (0, _getPrototypeOf2.default)(BookingRequestDetail)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      info: { title: {}, message: [] },
      showBill: false,
      showInfo: false
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(BookingRequestDetail, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          bookingRequestId = _props.params.bookingRequestId,
          loadBookingRequest = _props.loadBookingRequest;

      loadBookingRequest(bookingRequestId);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var bookingRequestId = nextProps.params.bookingRequestId,
          loadBookingRequest = nextProps.loadBookingRequest,
          cancelBooking = nextProps.cancelBooking,
          cancelBookingError = nextProps.cancelBookingError;

      if (this.props.toggleCancelSuccess !== nextProps.toggleCancelSuccess && nextProps.cancelBooking) {
        var title = { text: 'Thông báo', type: 'success' };
        var message = [{ text: cancelBooking.message }];
        var info = { title: title, message: message };
        this.setState({ info: info, showInfo: true });
        loadBookingRequest(bookingRequestId);
      }
      if (this.props.toggleCancelError !== nextProps.toggleCancelError && nextProps.cancelBookingError) {
        var _title = { text: 'Thông báo', type: 'error' };
        var _message = [{ text: cancelBookingError.message }];
        var _info = { title: _title, message: _message };
        this.setState({ info: _info, showInfo: true });
      }
    }
  }, {
    key: 'showBill',
    value: function showBill() {
      this.setState({ showBill: true });
    }
  }, {
    key: 'hideBill',
    value: function hideBill() {
      this.setState({ showBill: false });
    }
  }, {
    key: 'showInfo',
    value: function showInfo() {
      this.setState({ showInfo: true });
    }
  }, {
    key: 'hideInfo',
    value: function hideInfo() {
      this.setState({ showInfo: false });
    }
  }, {
    key: 'onCancel',
    value: function onCancel() {
      var _props2 = this.props,
          bookingRequestId = _props2.params.bookingRequestId,
          cancelBookingRequest = _props2.cancelBookingRequest;

      cancelBookingRequest(bookingRequestId);
    }
  }, {
    key: 'reRender',
    value: function reRender() {
      var _props3 = this.props,
          bookingRequest = _props3.bookingRequest,
          bill = _props3.bill;

      var previewData = null,
          QRData = null,
          shop = null,
          cancelable = null;
      if (bookingRequest && bill) {
        var status = bookingRequest.status;

        QRData = _Constant.BOOKING_STATUS[status];
        QRData.QRValue = this.props.params.bookingRequestId;
        cancelable = _Constant.BOOKING_STATUS[status].cancelable;
        shop = bookingRequest.shop;

        previewData = _support.Helper.subObject(bookingRequest, ['shop', 'time', 'slot', 'services', 'note', 'customer']);
        previewData.price = bill.total ? [bill.total] : [];
      }
      return { previewData: previewData, QRData: QRData, cancelable: cancelable, bill: bill, shop: shop };
    }
  }, {
    key: 'render',
    value: function render() {
      var styles = require('./BookingRequestDetail.scss');
      var _state = this.state,
          showBill = _state.showBill,
          showInfo = _state.showInfo,
          info = _state.info;
      var bookingRequest = this.props.bookingRequest;

      var _reRender = this.reRender(),
          previewData = _reRender.previewData,
          QRData = _reRender.QRData,
          cancelable = _reRender.cancelable,
          bill = _reRender.bill,
          shop = _reRender.shop;

      var colorCode = (0, _lib.getColorRatingCode)(shop ? shop.averagePoint : 0);
      var stylePoint = {
        backgroundColor: colorCode
      };
      console.warn('Booking Request', colorCode, bookingRequest, stylePoint);
      return _react2.default.createElement(
        'div',
        { className: styles.container },
        _react2.default.createElement(
          'div',
          { className: styles.content },
          bookingRequest && bookingRequest.atHome ? _react2.default.createElement(
            'div',
            { className: styles.titleTop },
            'D\u1ECACH V\u1EE4 L\xC0M \u0110\u1EB8P T\u1EA0I NH\xC0'
          ) : _react2.default.createElement(
            'div',
            { className: styles.titleTop },
            'D\u1ECACH V\u1EE4 T\u1EA0I SHOP'
          ),
          !!(shop && shop.shopType === 'freelance' && bookingRequest.status === 'acceptByMerchant') && _react2.default.createElement(
            'div',
            { className: styles.head },
            _react2.default.createElement('img', {
              src: shop.image || _Images2.default.account.defaultFreelance,
              alt: 'nh\xE2n vi\xEAn t\u1EA1i nh\xE0'
            }),
            !!(shop && (shop.averagePoint || shop.averagePoint === 0)) && _react2.default.createElement(
              'label',
              { htmlFor: '', style: stylePoint },
              shop.averagePoint === 0 ? '--' : shop.averagePoint
            ),
            _react2.default.createElement(
              'span',
              { className: styles.freelanceName },
              shop.name
            ),
            _react2.default.createElement(
              'span',
              null,
              '\u0111\xE3 nh\u1EADn l\u1ECBch c\u1EE7a b\u1EA1n'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles.block + ' ' + styles.blockInfo },
            QRData && _react2.default.createElement(_components.QRStatus, QRData),
            _react2.default.createElement('div', { className: styles.dash }),
            previewData && _react2.default.createElement(_components.PreviewBooking, {
              className: styles.preview,
              data: previewData,
              onClick: this.showBill.bind(this)
            })
          ),
          _react2.default.createElement(
            'div',
            { className: styles.block },
            !!(shop && shop.shopType !== 'freelance') && _react2.default.createElement(_components.PreviewLabel, {
              className: styles.address,
              name: shop.name,
              sub: [shop.address],
              iconUrl: '/booking/new_place_accepted.png'
            })
          ),
          !!cancelable && _react2.default.createElement(
            'div',
            { className: styles.btnRemove, onClick: this.onCancel.bind(this) },
            _react2.default.createElement('img', { src: '/booking/bin.png', alt: '' }),
            _react2.default.createElement(
              'span',
              { className: styles.removeLabel },
              'H\u1EE6Y \u0110\u1EB6T CH\u1ED6 N\xC0Y'
            )
          )
        ),
        _react2.default.createElement(
          _components.ModalCustom,
          { show: showBill, onHide: this.hideBill.bind(this) },
          _react2.default.createElement(_components.Bill, { data: bill, onClose: this.hideBill.bind(this) })
        ),
        _react2.default.createElement(_components.ModalCustom, {
          show: showInfo,
          onHide: this.hideInfo.bind(this),
          title: info.title,
          closeButton: true,
          message: info.message
        })
      );
    }
  }]);
  return BookingRequestDetail;
}(_react.Component), _class2.propTypes = {
  // @data
  params: _react.PropTypes.object,
  submit: _react.PropTypes.object,
  bookingRequest: _react.PropTypes.object,
  bill: _react.PropTypes.object,
  cancelBooking: _react.PropTypes.object,
  cancelBookingError: _react.PropTypes.object,
  toggleCancelSuccess: _react.PropTypes.bool,
  toggleCancelError: _react.PropTypes.bool,
  // @action
  loadBookingRequest: _react.PropTypes.func,
  cancelBookingRequest: _react.PropTypes.func
}, _temp2)) || _class);
exports.default = BookingRequestDetail;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Booking/BookingRequestDetail.js
// module id = 1532
// module chunks = 0